export enum ETimeSlot {
    none = 1,
    morning = 2,
    afternoon = 3,
}